export const RadnoVrijemeSumEvdResourceBS: RadnoVrijemeSumEvdInterface = {
  title: "Lista Radnog Vremena",
  errors: {
    query:
      "Doslo je do greske tokom loadiranja korisnika. Molimo kontaktirajte administratora.",
  },
  inputFields: {
    branch: {
      placeholder: "Odaberite poslovnicu",
      notFound: "Ni jedna poslovnica nije pronadjena",
    },
    endDate: {
      label: "Krajnji datum",
    },
    startDate: {
      label: "Pocetni datum",
    },
    user: {
      error: "Molimo odaberite korisnika",
      label: "Odabir korisnika",
      name: "user",
      placeholder: "Odaberite korisnika",
    },
  },
  pdf: {
    button: "Download PDF",
    document: {
      name: "Ime i prezime",
      title: "Evidencija radnog vremena",
      odabraniPeriod: "Odabrani period",
      ukupnoVrijeme: "Ukupno sati",
      potpisFooter: "Potpis",
      upisaoFooter: "Odobrio",
      entryType: "Tip evidencije",
      napomena: "Napomena",
      pocetak: "Pocetak",
      pocetakPauze: "Pocetak pauze",
      potpisano: "Potpis",
      zavrsetak: "Zavrsetak",
      zavrsetakPauze: "Zavrsetak pauze",
      tipovi: {
        DEZURA: "Dezura",
        ODSUSTVO: "Odsustvo",
        PRIPRAVNOST: "Pripravnost",
        RADNOVRIJEME: "Radno vrijeme",
        RADUSMJENAMA: "Rad u smjenama",
        TERENSKIRAD: "Terenski rad",
        BOLOVANJE: "Bolovanje",
        SLOBODANDAN: "Slobodan dan",
      },
    },
  },
  sihtarica: {
    periodLabel: "Period (mjesec)",
    statusOpen: "Otvoreno",
    statusLocked: "Zaključano",
    statusApproved: "Odobreno",
    lock: "Odobri / Zaključaj",
    approveSelected: "Odobri odabrano",
    approveNoneSelected: "Odaberite barem jedan zapis za odobrenje.",
    approvedOk: "Odabrani zapisi su odobreni.",
    unapprove: "Poništi odobrenje",
    unapproveOk: "Odobrenje je poništeno.",
    reopen: "Ponovo otvori",
    viewByWorker: "Po radnicima",
    viewByDay: "Po danima",
    batchEdit: "Grupna izmjena",
    edit: "Uredi",
    delete: "Obriši",
    deleteConfirm: "Da li ste sigurni da želite obrisati ovaj zapis?",
    deleteOk: "Zapis je obrisan.",
    addEntry: "Dodaj zapis",
    addEntryTitle: "Dodaj radno vrijeme",
    save: "Sačuvaj",
    cancel: "Otkaži",
    editReason: "Obrazloženje izmjene",
    editReasonRequired: "Obrazloženje izmjene je obavezno.",
    pdfOnlyLocked:
      "PDF se može preuzeti tek nakon što je period zaključan.",
    lockedOk: "Period je zaključan.",
    reopenedOk: "Period je ponovo otvoren.",
    editOk: "Izmjena je sačuvana.",
    addOk: "Zapis je dodan.",
    batchOk: "Grupna izmjena je sačuvana.",
    actionError: "Akcija nije uspjela.",
    errorDuplicateEntry:
      "Već postoji unos sa istim tipom i vremenom za ovaj dan. Promijenite tip ili satnicu.",
    empty: "Nema zapisa za odabrani period.",
    totalHours: "Ukupno",
    deviation: "Prekoračenje",
    colDate: "Datum",
    colWorker: "Radnik",
    colType: "Tip",
    colIn: "Dolazak",
    colOut: "Odlazak",
    colHours: "Sati",
    colNote: "Napomena",
  },
};

interface InputFieldInterface {
  label: string;
  name: string;
  placeholder: string;
  error: string;
}

export interface RadnoVrijemePDFSumInterface {
  name: string;
  title: string;
  odabraniPeriod: string;
  potpisFooter: string;
  upisaoFooter: string;
  entryType: string;
  pocetak: string;
  zavrsetak: string;
  pocetakPauze: string;
  zavrsetakPauze: string;
  napomena: string;
  potpisano: string;
  ukupnoVrijeme: string;
  tipovi: {
    RADNOVRIJEME: string;
    RADUSMJENAMA: string;
    TERENSKIRAD: string;
    DEZURA: string;
    PRIPRAVNOST: string;
    ODSUSTVO: string;
    BOLOVANJE: string;
    SLOBODANDAN: string;
  };
}

export interface RadnoVrijemeSumEvdInterface {
  title: string;
  errors: {
    query: string;
  };
  inputFields: {
    branch: {
      placeholder: string;
      notFound: string;
    };
    startDate: {
      label: string;
    };
    endDate: {
      label: string;
    };
    user: InputFieldInterface;
  };
  pdf: {
    button: string;
    document: RadnoVrijemePDFSumInterface;
  };
  sihtarica: {
    periodLabel: string;
    statusOpen: string;
    statusLocked: string;
    statusApproved: string;
    lock: string;
    approveSelected: string;
    approveNoneSelected: string;
    approvedOk: string;
    unapprove: string;
    unapproveOk: string;
    reopen: string;
    viewByWorker: string;
    viewByDay: string;
    batchEdit: string;
    edit: string;
    delete: string;
    deleteConfirm: string;
    deleteOk: string;
    addEntry: string;
    addEntryTitle: string;
    save: string;
    cancel: string;
    editReason: string;
    editReasonRequired: string;
    pdfOnlyLocked: string;
    lockedOk: string;
    reopenedOk: string;
    editOk: string;
    addOk: string;
    batchOk: string;
    actionError: string;
    errorDuplicateEntry: string;
    empty: string;
    totalHours: string;
    deviation: string;
    colDate: string;
    colWorker: string;
    colType: string;
    colIn: string;
    colOut: string;
    colHours: string;
    colNote: string;
  };
}
